<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'customer'],
		data () {
			return {
				modal: {
					selector: 'modal-create-accounts-' + new Date().getTime(),
				},

				payment_methods: null,
				statuses: null,

				item: {
					name: null,
					account_holder: null,
					account_number: null,
					url: null,
					payment_method_id: null,
					status_id: 2,
					customer_id: null,
				},
			}
		},
		created() {
			if(this.customer) {
				this.item.customer_id = this.customer.id
			}
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getPaymentMethos()
				this.getStatuses()
			},
			clearData() {
				this.item.name = null
				this.item.account_holder = null
				this.item.account_number = null
				this.item.url = null
				this.item.payment_method_id = null
				this.item.status_id = 2
				this.errors.clear()
			},
			getPaymentMethos() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.payment_methods = response.body
				})
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store () {
				var btnStore = Ladda.create(this.$refs.btnStore)
				btnStore.start()
				this.$http.post('admin/management/collection/account', this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					btnStore.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					btnStore.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/accounts/views/Create.vue